// Brand names, not Slovak words: Slovak collation would file "CHIEFTEC" after "H" (ch follows h).
const collator = new Intl.Collator('en', { sensitivity: 'base', numeric: true });

export function compareNames(a: { name: string }, b: { name: string }) {
  return collator.compare(a.name.trim(), b.name.trim());
}
